<template>
	<div>
		<CRow>
			<CCol col="4">
				<CInput name="reference" label="Référence du point de vente" :value="item.reference" />
			</CCol>
		</CRow>

		<hr />

		<CRow>
			<CCol col="6">
				<CInput name="name" label="Nom du point de vente" :value="item.name" />
			</CCol>
			<CCol col="6">
				<div class="form-group">
					<label>Transporteur</label>
					<GTreeView
						input-name="carrier"
						fetch-url="/api/carriers"
						:multiple="false"
						placeholder="Choisissez un transporteur..."
						:value="item.carrier != null ? item.carrier['@id'] : null" />
				</div>
			</CCol>
		</CRow>

		<hr />

		<CRow>
			<CCol col="6">
				<CInput name="address" label="Adresse" :value="item.address" />
			</CCol>
		</CRow>
		<CRow>
			<CCol col="6">
				<CInput name="address2" label="Complément d'adresse" :value="item.address2" />
			</CCol>
		</CRow>
		<CRow>
			<CCol col="4">
				<CInput name="city" label="Ville" :value="item.city" />
			</CCol>
			<CCol col="4">
				<CInput name="postalCode" label="Code postal" :value="item.postalCode" />
			</CCol>
			<CCol sm="4">
				<div class="form-group">
					<label>Pays</label>
					<GTreeView
						input-name="country"
						fetch-url="/api/countries?itemsPerPage=246"
						:multiple="false"
						placeholder="Choisissez un pays..."
						:value="item.country != null ? item.country['@id'] : null" />
				</div>
			</CCol>
		</CRow>

		<hr />

		<CRow>
			<CCol col="6">
				<CInput name="gpsLatitude" label="GPS - Latitude" :value="item.gpsLatitude" />
			</CCol>

			<CCol col="6">
				<CInput name="gpsLongitude" label="GPS - Longitude" :value="item.gpsLongitude" />
			</CCol>
		</CRow>

		<hr />

		<CRow>
			<CCol sm="12">
				<CFormGroup class="form-group">
					<template #label>
						<label>Type</label>
					</template>
					<template #input>
						<CRow>
							<CCol>
								<GSwitchSmall
									label="Point de vente"
									name="isPointOfSale"
									:checked.sync="item.isPointOfSale" />
							</CCol>

							<CCol>
								<GSwitchSmall
									label="Point de dépôt"
									name="isPointOfDepot"
									:checked.sync="item.isPointOfDepot" />
							</CCol>
						</CRow>
					</template>
				</CFormGroup>
			</CCol>

			<CCol sm="12">
				<CFormGroup class="form-group">
					<template #label>
						<label>Commissions</label>
					</template>
					<template #input>
						<CRow>
							<CCol>
								<CInput
									name="saleCommission"
									placeholder="Point de vente"
									label="Point de vente"
									:value="item.saleCommission" />
							</CCol>

							<CCol>
								<CInput
									name="depotCommission"
									placeholder="Point de dépôt"
									label="Point de dépôt"
									:value="item.depotCommission" />
							</CCol>

							<CCol>
								<CInput
									name="suppWeightCommission"
									placeholder="KG Supp."
									label="KG Supp."
									:value="item.suppWeightCommission" />
							</CCol>
						</CRow>
					</template>
				</CFormGroup>
			</CCol>
		</CRow>

		<hr />

		<CRow>
			<CCol sm="6">
				<GSwitchSmall name="active" label="Active" :checked="item.active" />
			</CCol>
		</CRow>
	</div>
</template>

<script>
	import GTreeView from '../../../components/ghostlexly-components/GTreeView';
	import GSwitchSmall from '../../../components/ghostlexly-components/GSwitchSmall';

	export default {
		name: 'FormModal',

		components: {
			GSwitchSmall,
			GTreeView,
		},

		props: {
			item: {
				type: Object,
				default: () => {
					return {};
				},
			},
		},

		data() {
			return {
				active: false,
			};
		},
	};
</script>
